/**
 * HTML Learning Package Bridge — message envelope and payload types.
 *
 * Full contract & security model: docs/html-package-bridge.md
 * Runtime helpers (host + guest): @wlh/learning-bridge
 *
 * Design rules encoded here:
 *  - Every message carries `bridgeVersion` and a `sessionToken`.
 *  - Opening a package is never completion — completion is only ever a
 *    validated MODULE_COMPLETED event (MVP Spec §5, Master Brief §6).
 *  - Forward-compatible: unknown fields are ignored by receivers.
 */
export const BRIDGE_VERSION = "1.0";
/** Host (LMS shell) -> guest (HTML package) message types. */
export const HOST_MESSAGE_TYPES = [
    "LMS_INIT",
    "STATE_SAVED",
    "COMPLETION_ACCEPTED",
    "COMPLETION_REJECTED",
];
/** Guest (HTML package) -> host (LMS shell) message types. */
export const GUEST_MESSAGE_TYPES = [
    "MODULE_STARTED",
    "PROGRESS_UPDATED",
    "STATE_SAVE",
    "MODULE_COMPLETED",
];
//# sourceMappingURL=bridge.js.map